import useProtoMethod from "./useProtoMethod";
import {
  ListAgentConversationsRequest,
  ListAgentConversationsResponse,
  ListSmsBotConversationsRequest,
  ListSmsBotConversationsResponse,
  GetAgentConversationRequest,
  GetAgentConversationResponse,
  GetSmsBotConversationRequest,
  GetSmsBotConversationResponse,
  SendAgentMessageRequest,
  SendAgentMessageResponse,
} from "protogen/agent_conversation_service_pb";

const useListAgentConversations = (
  callback?: (r: ListAgentConversationsResponse) => void,
) => {
  return useProtoMethod<
    ListAgentConversationsRequest,
    ListAgentConversationsResponse
  >("ListAgentConversations", ListAgentConversationsResponse, { callback });
};

const useGetAgentConversation = (
  callback?: (r: GetAgentConversationResponse) => void,
) => {
  return useProtoMethod<
    GetAgentConversationRequest,
    GetAgentConversationResponse
  >("GetAgentConversation", GetAgentConversationResponse, { callback });
};

const useListSmsBotConversations = (
  callback?: (r: ListSmsBotConversationsResponse) => void,
) => {
  return useProtoMethod<
    ListSmsBotConversationsRequest,
    ListSmsBotConversationsResponse
  >("ListSmsBotConversations", ListSmsBotConversationsResponse, { callback });
};

const useGetSmsBotConversation = (
  callback?: (r: GetSmsBotConversationResponse) => void,
) => {
  return useProtoMethod<
    GetSmsBotConversationRequest,
    GetSmsBotConversationResponse
  >("GetSmsBotConversation", GetSmsBotConversationResponse, { callback });
};

const useSendAgentMessage = (
  callback?: (r: SendAgentMessageResponse) => void,
) => {
  return useProtoMethod<SendAgentMessageRequest, SendAgentMessageResponse>(
    "SendAgentMessage",
    SendAgentMessageResponse,
    { callback, rethrowClientErrors: true },
  );
};

export {
  useListAgentConversations,
  useListSmsBotConversations,
  useGetAgentConversation,
  useGetSmsBotConversation,
  useSendAgentMessage,
};
